// Module
var code = " <mat-toolbar><h3>{{'lbl_index_values' | translate}}</h3></mat-toolbar> <gh-grid class=\"theme-fya flex-1\" [definition]=\"definition\" [ghGridModelData]=\"form.thresholds$ | async\" [focusedCell]=\"form.focusedCell$ | async\" (focusedCellChange)=\"onFocusedCellChange()\" [hasSettings]=\"false\"></gh-grid> ";
// Exports
module.exports = code;